/**
 * Parse a structure/scan timestamp into a `Date`. Accepts every shape a
 * timestamp reaches the client in: Firestore `Timestamp`, a JSON-serialized
 * `{ _seconds }`, a `Date`, an ISO string, or epoch millis. Returns null for
 * anything unparseable — callers render nothing rather than "Invalid Date".
 *
 * Split out from the formatter because the same shapes have to be COMPARED as
 * well as displayed (see `processStatusItems`), and a second parser would be a
 * second list of shapes to keep in step.
 */
export function timestampToDate(timestamp) {
  if (!timestamp) return null;
  let date;
  if (typeof timestamp.toDate === 'function') {
    date = timestamp.toDate();
  } else if (timestamp instanceof Date) {
    date = timestamp;
  } else if (typeof timestamp === 'string' || typeof timestamp === 'number') {
    date = new Date(timestamp);
  } else if (Number.isFinite(timestamp._seconds)) {
    date = new Date(timestamp._seconds * 1000);
  } else {
    return null;
  }
  return Number.isNaN(date.getTime()) ? null : date;
}

/** Format a structure/scan timestamp for display. '' when unparseable. */
export function formatStructureDate(timestamp) {
  const date = timestampToDate(timestamp);
  if (!date) return '';
  return date.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
}
